// extracted by mini-css-extract-plugin
module.exports = {"catcher":"styles-m__catcher---6cxTy"};